import { NgClass } from '@angular/common';
import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { HeaderShellComponent } from '../header-shell/header-shell.component';

@Component({
  selector: 'grid-engine-basic-header-cell',
  templateUrl: './basic-header-cell.component.html',
  imports: [HeaderShellComponent, TranslatePipe, NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./basic-header-cell.component.scss']
})
export class BasicHeaderCellComponent implements IHeaderAngularComp {
  params: WritableSignal<IHeaderParams & { skipTextTransform?: boolean }> = signal(null);

  agInit(params: IHeaderParams & { skipTextTransform?: boolean }): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
